import axios from "axios";
import config from "../../config";
import axiosInstance from "../../utils/axiosInstance";


const BookDonationManager = {
  /**
   * Fetch all book donation entries
   * @returns {Promise<Array>} array of BookDonateDTO
   */
  async getAllDonations() {
    const response = await axiosInstance.get(`/book_donations`);
    // assuming ApiResponse structure: { responseData: [...] }
    return response.data.responseData;
  },

  /**
   * Fetch a single book donation by ID
   * @param {number|string} id
   * @returns {Promise<Object>} BookDonateDTO
   */
  async getDonationById(id) {
    const response = await axiosInstance.get(`/book_donations/${id}`);
    return response.data.responseData;
  },

  /**
   * Create a new book donation
   * @param {Object} donationData - fields matching BookDonateDTO
   * @returns {Promise<Object>} created BookDonateDTO
   */
  async createDonation(donationData) {
    const response = await axiosInstance.post(`/book_donations/create`, donationData);
    return response.data.responseData;
  },

  /**
   * Delete a book donation entry by ID
   * @param {number|string} id
   * @returns {Promise<void>}
   */
  async deleteDonation(id) {
    const response = await axiosInstance.delete(`/book_donations/${id}`);
    return response.data;
  },
};

export default BookDonationManager;
